import React from 'react';

import {
  useSessionTokensState,
  useSessionTokensActions
} from './SessionTokensContext';

import {
  getSessionTokens,
} from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const SessionTokensPageController = () => {
  const sessionTokensState = useSessionTokensState();
  const { onResponse, onError } = useSessionTokensActions();

  return (
    <PageController
      pageNumber={sessionTokensState?.pageNumber}
      numberOfPages={sessionTokensState?.numberOfPages}
      goToFirstPage={() => {
        getSessionTokens({
          onResponse,
          onError,
          pageNumber: 1,
        });
      }}
      goToPreviousPage={() => {
        getSessionTokens({
          onResponse,
          onError,
          pageNumber: (sessionTokensState?.pageNumber - 1),
        });
      }}
      goToNextPage={() => {
        getSessionTokens({
          onResponse,
          onError,
          pageNumber: (sessionTokensState?.pageNumber + 1),
        });
      }}
      goToLastPage={() => {
        getSessionTokens({
          onResponse,
          onError,
          pageNumber: sessionTokensState?.numberOfPages,
        });
      }}
    />
  );
};

export default SessionTokensPageController;
